<template>
  <div>
    <navbar-view id = "navview" ref="navview"/>
    <Landing style="height: auto;"/>
    <b-container
      id="nav-scroller"
      class="body"
    >
      <About/>
      <Skill/>
      <Exp/>
      <Edu/>
      <Proj/>
      <Cont/>
    </b-container>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from '@/components/NavBar'
import Footer from '@/components/Footer'
import Landing from '@/components/Landing'
import About from '@/components/About'
import Skill from '@/components/Skill'
import Experience from '@/components/Experience'
import Education from '@/components/Education'
import Project from '@/components/Project'
import ContactMe from '@/components/Contact'

export default {
  name: 'home',
  components: {
    'navbar-view': NavBar,
    Footer,
    Landing,
    About,
    Skill,
    'Exp': Experience,
    'Edu': Education,
    'Proj': Project,
    'Cont': ContactMe
  }
}
</script>

<style>
.body {
  padding-left: 10px;
  position: relative;
  overflow-y: auto;
}

#top {
  content:"";
  display:block;
}

</style>
